import React, { useState, useEffect } from 'react';
import {
    Dialog, Button, TextField, Box, Typography, IconButton,
} from '@mui/material';
import CloseIcon from '@material-ui/icons/Close';
import { isValidEmail } from '../../../utils/utils';
import useStyles from '../../../assets/styles/HomeStyles';

const defaultFields = { email: '', first_name: '', last_name: '' };

const CreatePeerDialog = ({ open, onClose, onSubmit, loading }) => {
    const classes = useStyles();
    const [fields, setFields] = useState(defaultFields);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (open) { setFields(defaultFields); setErrors({}); }
    }, [open]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields(f => ({ ...f, [name]: value }));
    };

    const handleCreate = () => {
        const newErrors = {};
        if (!fields.email) {
            newErrors.email = 'Required';
        } else if (!isValidEmail(fields.email)) {
            newErrors.email = 'Invalid email address';
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) onSubmit(fields);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '15px',
                    overflow: { xs: 'scroll', sm: 'hidden' },
                    backgroundColor: 'var(--brand-surface, #fff)',
                }
            }}
        >
            <Box sx={{ p: 4, position: 'relative' }}>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8, color: 'var(--brand-text-muted, #999)' }}
                >
                    <CloseIcon />
                </IconButton>

                <Typography variant="h5" sx={{ mt: 2, mb: 4, textAlign: 'center', color: '#ff5757', fontWeight: 'bold' }}>
                    Add Peer
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        label="Email *"
                        name="email"
                        type="email"
                        value={fields.email}
                        onChange={handleChange}
                        error={!!errors.email}
                        helperText={errors.email || 'Login credentials will be emailed to this address'}
                        fullWidth
                    />
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            label="First Name"
                            name="first_name"
                            value={fields.first_name}
                            onChange={handleChange}
                            fullWidth
                        />
                        <TextField
                            label="Last Name"
                            name="last_name"
                            value={fields.last_name}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 4 }}>
                    <Button
                        className={classes.popupButton}
                        variant="outlined"
                        disabled={loading}
                        onClick={onClose}
                        sx={{ width: '30%', borderColor: '#ff5757', color: '#ff5757', fontWeight: 'bold', fontSize: '15px !important' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        className={classes.popupButton}
                        variant="contained"
                        disabled={loading}
                        onClick={handleCreate}
                        sx={{ width: '30%', fontSize: '15px !important' }}
                    >
                        {loading ? 'Adding...' : 'Add Peer'}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};

export default CreatePeerDialog;
